import { useMemo, useState } from "react";
import { formatMoney, NAIRA_SYMBOL } from "../utils";

export function MoneyCalculator() {
  const [amount, setAmount] = useState<number | null>(null);

  function getFeeOnTotal(total: number) {
    return (total * 0.03) + 100;
  }

  const totalAmount = useMemo(() => {
    if (!amount) return 0;
    let total = amount;
    return total + getFeeOnTotal(total);
  }, [amount]);

  return (
    <div style={{ marginTop: "30px", padding: "50px" }}>
      <input
        className='form-control'
        onChange={({ target: { value } }) => setAmount(Number(value))}
        value={amount ?? 0}
      />
      <center>
        <p style={{ marginTop: "30px" }}>
          Total Amount:{" "}
          <b>
            {NAIRA_SYMBOL}
            {formatMoney(Number(totalAmount))}
          </b>
        </p>
      </center>
    </div>
  );
}
